// src/utils/resumeContentHelper.js
import { resumeApi, jobApi } from '../services/api';

/**
 * Helper function to get resume content, either from provided data or by fetching it
 * @param {string} resumeId - The resume ID
 * @param {string} versionId - The version ID (optional)
 * @param {Object} existingContent - Existing content if available (optional)
 * @returns {Promise<Object>} - The resume content
 */
export const getResumeContentSafe = async (resumeId, versionId = null, existingContent = null) => {
  // If we already have content, use it
  if (existingContent && Object.keys(existingContent).length > 0) {
    return existingContent;
  }
  
  try {
    // If version ID is provided, get that specific version
    if (versionId) {
      const response = await resumeApi.getResumeVersion(resumeId, versionId);
      if (response && response.data) {
        return response.data.content;
      }
    }
    
    // Otherwise get the resume and use the first version
    const response = await resumeApi.getResumeById(resumeId);
    if (response && response.data && response.data.versions && response.data.versions.length > 0) {
      const firstVersion = response.data.versions[0];
      return firstVersion.content;
    }
  } catch (error) {
    console.error('Error fetching resume content:', error);
  }
  
  return null;
};

/**
 * Helper function to get job content, either from provided data or by fetching it
 * @param {string} jobId - The job ID
 * @param {Object} existingContent - Existing content if available (optional)
 * @returns {Promise<Object>} - The job content
 */
export const getJobContentSafe = async (jobId, existingContent = null) => {
  // If we already have content, use it
  if (existingContent && Object.keys(existingContent).length > 0) {
    return existingContent;
  }
  
  try {
    const response = await jobApi.getJobById(jobId);
    if (response && response.data && response.data.content) {
      return response.data.content;
    }
  } catch (error) {
    console.error('Error fetching job content:', error);
  }
  
  return null;
};